import { mergeAttributes, Node, nodeInputRule } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import Component from "./EmbedInlineData.vue";

export default Node.create({
  name: "embedInlineData",
  group: "inline",
  atom: true,
  inline: true,
  selectable: false,
  addAttributes() {
    return {
      path: null,
      selection: null,
      children: null
    };
  },
  parseHTML() {
    return [
      {
        tag: "embed-inline-data"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["embed-inline-data", mergeAttributes(HTMLAttributes)];
  },
  addInputRules() {
    return [nodeInputRule({ find: /}}/g, type: this.type })];
  },
  addNodeView() {
    return VueNodeViewRenderer(Component);
  }
});
